import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function UrgencyScarcity() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-brand-bg-light border-y border-brand-red/20" data-id="element-350">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-352">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-353">
            <ClockIcon className="w-10 h-10 text-brand-red" data-id="element-354" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-355">
              {t('urgency.title')}
            </h2>
          </div>

          <div className="bg-brand-bg-dark p-8 sm:p-12 rounded-xl border-l-4 border-brand-red shadow-lg text-center sm:text-left" data-id="element-356">
            <p className="text-xl sm:text-2xl text-white mb-6 leading-relaxed" data-id="element-357">
              <strong className="text-brand-red uppercase tracking-wider mr-2" data-id="element-358">
                {t('urgency.p1_strong')}
              </strong>
              {t('urgency.p1')}
            </p>

            <p className="text-lg text-gray-400 mb-8" data-id="element-359">{t('urgency.p2')}</p>

            <div className="bg-brand-red/10 border border-brand-red/30 p-6 rounded-lg mb-10 text-center" data-id="element-360">
              <p className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-361">
                {t('urgency.highlight1')}
                <span className="text-brand-red" data-id="element-362">
                  {t('urgency.highlight2')}
                </span>
              </p>
            </div>

            <p className="text-xl text-gray-300 text-center mb-10" data-id="element-363">
              {t('urgency.p3')}
              <strong className="text-brand-gold" data-id="element-364">
                {t('urgency.p3_strong')}
              </strong>{' '}
              {t('urgency.p3_end')}
            </p>

            <div className="text-center" data-id="element-365">
              <motion.a href="tel:2029132653" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-block bg-brand-red hover:bg-red-700 text-white px-8 py-4 rounded-md font-heading font-bold text-xl uppercase tracking-wide transition-colors shadow-lg shadow-brand-red/20" data-id="element-366">
                {t('urgency.button')}
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}